import React from 'react';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { IoMdWarning } from 'react-icons/io';
import { MdNearMe, MdPlace } from 'react-icons/md';
import { useHistory, useParams } from 'react-router';
import { PropsFromRedux } from '.';
import { ReactComponent as Dots } from '../../assets/icons/dots.svg';
import { ReactComponent as RiderIcon } from '../../assets/icons/loading-rider.svg';

import { API_KEYS } from '../../interfaces/api';
import { PARTNER_DETAILS } from '../../interfaces/wallet.interface';
import TextInput from '../form-controls/TextInput';

interface Props extends PropsFromRedux {}

const TrackRider: React.FC<Props> = ({
  resetApi,
  trackRider,
  trackRiderState,
}) => {
  const history = useHistory();
  const { trackingCode } = useParams<{ trackingCode: string }>();
  const { loading, error, response } = trackRiderState || {};

  React.useEffect(() => {
    if (trackingCode) {
      trackRider(trackingCode);
    }
    return () => {
      resetApi(API_KEYS.GET_PARTNER_DETAILS);
    };
  }, [trackingCode, trackRider, resetApi]);

  const trackingObject: PARTNER_DETAILS = response?.data;
  const defaultMapUrl = `https://www.google.com/maps/embed/v1/place?q=My+Location&zoom=15&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

  const mapUrl = `https://www.google.com/maps/embed/v1/directions?origin=${trackingObject?.senderLocation.lat},${trackingObject?.senderLocation.lng}&destination=${trackingObject?.receiverLocation.lat},${trackingObject?.receiverLocation.lng}&waypoints=${trackingObject?.partnerCurrentLocation?.lat},${trackingObject?.partnerCurrentLocation?.lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

  return (
    <div className="w-full p-4 mt-10 bg-white rounded-lg">
      <div className="flex items-center mb-10">
        <button type="button" onClick={() => history.go(-1)}>
          <HiOutlineArrowNarrowLeft className="inline-flex text-2xl" />
        </button>
        <h4 className="flex-grow text-2xl font-bold text-center">
          Track Rider
        </h4>
      </div>
      <div className="flex flex-wrap items-center justify-between w-full px-4 py-8 mb-10 shadow-lg md:flex-nowrap rounded-xl">
        <div className="flex items-center w-full mb-5 md:mb-0 md:w-6/12">
          <MdNearMe className="mt-5 mr-2 text-xl text-yellow-400" />
          <TextInput
            className="w-full p-4 text-sm bg-gray-200 rounded-lg"
            wrapperClassName="w-full"
            labelClassName="text-sm mb-2 flex font-medium"
            placeholder="Pickup Address"
            label="Pickup Address"
            id="SenderLocation"
            name="SenderLocation"
            value={trackingObject?.senderAddress}
            disabled
          />
        </div>

        <div className="hidden px-6 md:flex">
          <Dots className="mt-8 text-9xl" />
        </div>
        <div className="flex items-center flex-grow w-full md:w-6/12">
          <MdPlace className="mt-5 mr-2 text-xl text-green-400" />
          <TextInput
            className="w-full p-4 text-sm bg-gray-200 rounded-lg"
            wrapperClassName="w-full"
            labelClassName="text-sm mb-2 flex font-medium"
            placeholder="Drop-Off Address"
            label="Drop-Off Address"
            id="ReceiverLocation"
            name="ReceiverLocation"
            value={trackingObject?.receiverAddress}
            disabled
          />
        </div>
      </div>

      <div className="relative flex w-full mb-10 rounded-xl">
        <iframe
          aria-hidden="false"
          title="googlemaps"
          width="100%"
          height="450"
          className="rounded-xl"
          frameBorder="0"
          style={{
            filter: 'grayscale(13) brightness(0.9) invert(1)',
            border: 0,
          }}
          loading="lazy"
          allowFullScreen
          src={
            trackingObject?.receiverLocation && trackingObject?.senderLocation
              ? mapUrl
              : defaultMapUrl
          }
        />
        <div className="absolute flex items-center justify-center w-full rounded-md bottom-3">
          <div className="w-full max-w-xs p-4 bg-white rounded-md">
            {loading && (
              <div className="flex flex-col items-center justify-center text-sm font-medium">
                <RiderIcon />
                Searching for a rider
              </div>
            )}
            {((error && !loading) ||
              (trackingObject && !trackingObject.assignedPartner)) && (
              <div className="flex flex-col items-center justify-center font-medium">
                <IoMdWarning className="text-2xl text-yellow-400" />
                <p className="text-sm text-center">
                  Sorry, no dispatch rider at the moment, we will assign a rider
                  to you in few minutes
                </p>
                <button
                  type="button"
                  onClick={() => trackRider(trackingCode)}
                  className="p-4 px-4 py-3 text-white rounded bg-secondary"
                >
                  Try Again
                </button>
              </div>
            )}
            {!loading && response && (
              <div className="flex">
                <div>
                  <img
                    src=""
                    className="w-8 h-8 border border-gray-100 rounded-full"
                    alt=""
                  />
                </div>
                <div className="ml-5">
                  <h4 className="font-semibold">Boris Johnsons</h4>
                  <a className="text-gray-400" href="tel:34343434">
                    08080343434
                  </a>
                  <p className="font-semibold text-green-600">4.88 Ratings</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackRider;
